// extracted by mini-css-extract-plugin
export var container = "ResultScreen-module--container--ZJgGO";
export var contentContainer = "ResultScreen-module--contentContainer--ftwxb";
export var heroPanelContainer = "ResultScreen-module--heroPanelContainer--EI+rl";
export var swapGenderButton = "ResultScreen-module--swapGenderButton--xt6pV";
export var swapGenderIcon = "ResultScreen-module--swapGenderIcon--ZUV-b";
export var heroPanel = "ResultScreen-module--heroPanel--EuJFE";
export var heroDescriptionContainer = "ResultScreen-module--heroDescriptionContainer--8QU35";
export var heroLogo = "ResultScreen-module--heroLogo--AIJk2";
export var superPowerLabel = "ResultScreen-module--superPowerLabel--FEOSV";
export var superPower = "ResultScreen-module--superPower--Z+uQT";
export var weaknessLabel = "ResultScreen-module--weaknessLabel--oaJE9";
export var weakness = "ResultScreen-module--weakness--5YQR0";
export var divider = "ResultScreen-module--divider--xb6i9";
export var description = "ResultScreen-module--description--kLy-1";
export var buttonsContainer = "ResultScreen-module--buttonsContainer--GSXP2";
export var shareButton = "ResultScreen-module--shareButton--Aw5n2";
export var retryButton = "ResultScreen-module--retryButton--f3Xn8";
export var floatingShareButton = "ResultScreen-module--floatingShareButton--WVxbR";
export var floatingShareButtonVisible = "ResultScreen-module--floatingShareButtonVisible--C9bYH";